import { render } from "./CreateRegions.vue?vue&type=template&id=0b7b5454"
import script from "./CreateRegions.vue?vue&type=script&lang=js"
export * from "./CreateRegions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__